// extracted by mini-css-extract-plugin
module.exports = {"formBox":"create-studio_formBox__1ymni","bottomBox":"create-studio_bottomBox__1XTLp"};